import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material';

import { ScheduleCalendar } from 'components/ScheduleCalendar';

export const Calendar = () => {
  return (
    <Container maxWidth="xl">
      <Stack spacing={4}>
        {/* Page Header */}
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#2C3E50' }}>
            Calendar
          </Typography>
          <Typography variant="body2" sx={{ color: '#6B7280', mt: 0.5 }}>
            View and manage scheduled agent tasks
          </Typography>
        </Box>

        {/* Calendar Card */}
        <Card
          sx={{
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0, 153, 204, 0.1)',
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <ScheduleCalendar />
          </CardContent>
        </Card>
      </Stack>
    </Container>
  );
};
